import { useState, useEffect } from 'react';
import api from '../services/api';

export function useCoinPriceBalanceData(coin, range = '1m') {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    
    async function fetchData() {
      if (!coin) return;
      
      setLoading(true);
      setError(null);
      
      try {
        const params = new URLSearchParams({ coin, range });
        const response = await api.get(`/api/portfolio/coin-price-balance-data?${params}`);
        
        if (!cancelled) {
          setData(response.data);
        }
      } catch (err) {
        // Auto-retry once
        try {
          if (!cancelled) {
            const params = new URLSearchParams({ coin, range });
            const response = await api.get(`/api/portfolio/coin-price-balance-data?${params}`);
            setData(response.data);
          }
        } catch (retryErr) {
          // Silent failure - don't set error, just don't show data
          if (!cancelled) {
            console.warn(`Failed to load ${coin} price balance data after retry:`, retryErr);
          }
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    fetchData();
    
    return () => {
      cancelled = true;
    };
  }, [coin, range]);

  return { data, loading, error };
} 